import React from "react";
import Nav from "../components/Nav";
import Margin from "../components/Margin";
import Carousel from "../components/Carousel";

function App() {
  return (
    <div>
      <Nav />
      <Margin />
      <Carousel />
    </div>
  );
}
export default App;
